import { Reveal, SectionHeading } from "./Reveal";
import { CLIENT_TYPES } from "@/data/content";

const toSlug = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const WhoWeWorkWith = () => (
  <section
    id="who-we-work-with"
    data-testid="who-we-work-with-section"
    className="mx-auto max-w-7xl bg-[#0B0F17] px-4 py-24 shadow-[0_0_0_100vmax_#0B0F17] [clip-path:inset(0_-100vmax)] sm:px-8 lg:px-16 lg:py-32"
  >
    <div className="grid grid-cols-1 gap-14 lg:grid-cols-[0.9fr_1.1fr]">
      <div>
        <SectionHeading
          number="05"
          label="Who We Work With"
          title="Requirements we can support"
          tone="dark"
        />
        <Reveal delay={0.1}>
          <p className="mt-8 text-base font-light leading-relaxed text-slate-400">
            We work with a focused set of client profiles and transaction
            types. Suitability is always evaluated on the specifics of the
            business and the requirement.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-px self-start border border-white/10 bg-[#0D1220]/10 sm:grid-cols-2">
        {CLIENT_TYPES.map((type, i) => (
          <Reveal key={type} delay={i * 0.04} className="h-full">
            <div
              data-testid={`client-type-${toSlug(type)}`}
              className="group flex h-full items-center gap-4 bg-[#0B0F17] px-6 py-5 transition-colors duration-300 hover:bg-[#111827]"
            >
              <span
                className="h-1.5 w-1.5 rotate-45 bg-[#F26122]/50 transition-colors duration-300 group-hover:bg-[#F26122]"
                aria-hidden="true"
              />
              <span className="text-sm font-light text-slate-300">{type}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhoWeWorkWith;
